<app-dialog
  id="terms"
  [title]="'auth.termsOfService.header' | translate"
  [isSaving]="isSaving"
  (save)="onSubmit()"
  [confirmation]="'auth.termsOfService.accept' | translate"
  [cancel]="'auth.termsOfService.decline' | translate"
>
  <div>
    <p [innerHTML]="file"></p>
  </div>
</app-dialog>
